export default __webpack_public_path__ + "static/clouds-small-cb8ebc42366d33353c016bde9f04b962.png";